import { getCookie, setCookie } from '../../../../layout-common/js/parts/utils';

const COOKIE_NAME = 'jp_ait';
const AI_TAB_SELECTOR = '.sign.sign-ai';
const CLASSIC_TAB_SELECTOR = '.sign.sign-classic';
const COOKIE_EXPIRATION = 31536000; //1 year
//jqueryFree
export default function () {
	const showHideSignPanel = function () {
		const ait = getCookie(COOKIE_NAME);
		let showSelector, hideSelector;
		if (ait === '1') {
			showSelector = AI_TAB_SELECTOR;
			hideSelector = CLASSIC_TAB_SELECTOR;
		} else {
			showSelector = CLASSIC_TAB_SELECTOR;
			hideSelector = AI_TAB_SELECTOR;
		}

		let elements = document.querySelectorAll(showSelector);
		elements.forEach(function (element) {
			element.style.display = 'block';
		});

		elements = document.querySelectorAll(hideSelector);
		elements.forEach(function (element) {
			element.style.display = 'none';
		});
	};

	const showHideOffers = function () {
		const ait = getCookie(COOKIE_NAME);
		const isClassicSearch = document.querySelectorAll('.classic-search.active').length > 0;
		const seznam = document.getElementById('seznam');

		if (isClassicSearch) {
			seznam?.classList.remove('none');
		} else {
			seznam?.classList.add('none');
		}
	};
	function handleTabClick(event) {
		let tabDiv = event.target.closest('div');
		let cookieValue = '0';

		if (tabDiv.classList.contains('new')) {
			cookieValue = '1'; // Pokud je kliknuto na ai
		}
		setCookie(COOKIE_NAME, cookieValue, COOKIE_EXPIRATION); //1 year
		showHideSignPanel();
	}

	showHideSignPanel();
	showHideOffers();

	let tabDivs = document.querySelectorAll('.ai-selector .tabs > div');
	tabDivs.forEach(function (div) {
		div.addEventListener('click', handleTabClick);
	});

	//Pokud je nepřihlášený uživatel, je třeba řešit tabulátory Classic/Ai na frontendu
	//Pokud je nasetovaná cookie jp_ait na 1 (Ai), je potřeba změnit tabulátory a výpis vyhledávání
	let classicSearchTab = document.querySelector('main.page-offers .tabs .classic-search');
	let aiActive = getCookie(COOKIE_NAME) === '1';
	if (aiActive && classicSearchTab) {
		let newTab = document.querySelector('.new');
		if (classicSearchTab.classList.contains('active')) {
			let newSearchLink = document.querySelector('.new a');
			if (newSearchLink) {
				classicSearchTab.classList.remove('active');
				newTab.classList.add('active');
			}
			let classicSearchBox = document.querySelector('.tab-content.classic-tab');
			let aiSearchBox = document.querySelector('.tab-content.ai-tab');
			classicSearchBox.classList.remove('active');
			aiSearchBox.classList.add('active');
			document.querySelectorAll('[class*="switchtab-only-tab-"]').forEach((el) => el.classList.add('none'));
		}
	}

	//Nastavení cookie na classic search po odeslání vyhledávání submit buttonem
	let buttonSearch = document.querySelector('.common-search .submit');
	if (buttonSearch) {
		let buttonSearch = document.getElementById('frm-btn-submit');
		if (buttonSearch) {
			buttonSearch.addEventListener('click', function () {
				setCookie(COOKIE_NAME, '0', COOKIE_EXPIRATION); //1 year
			});
		}
	}
}
